import EditIcon from '@mui/icons-material/Edit'
import { Button, IconButton } from '@mui/material'
import { useMemo } from 'react'

import { IColumnsType } from 'pared/components/basicUi/table'

export interface IPrepItemTableData {
  key: string
  prepItem: string
  category: string
  onHandUnit: string
  restDays: number
}

interface UsePrepItemCategoryColumnsProps {
  onMenuItemDetailsClick?: (prepItemId: string, prepItemName: string) => void
  onEditClick?: (prepItemId: string, prepItemName: string) => void
  onRestDaysEditClick?: (
    prepItemId: string,
    prepItemName: string,
    restDays: number,
  ) => void
  onOnHandUnitEditClick?: (prepItemId: string, prepItemName: string) => void
}

const usePrepItemCategoryColumns = ({
  onMenuItemDetailsClick,
  onEditClick,
  onRestDaysEditClick,
  onOnHandUnitEditClick,
}: UsePrepItemCategoryColumnsProps = {}): IColumnsType<IPrepItemTableData>[] => {
  return useMemo(
    () =>
      [
        {
          key: 'prepItem',
          title: 'Prep Item',
          minWidth: '200px',
          align: 'left',
          render: (_: any, record: IPrepItemTableData) => (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <IconButton
                size="small"
                onClick={() => onEditClick?.(record.key, record.prepItem)}
                sx={{
                  padding: '4px',
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  },
                }}
              >
                <EditIcon sx={{ fontSize: '1.2rem' }} />
              </IconButton>
              <span>{record.prepItem}</span>
            </div>
          ),
        },
        {
          key: 'category',
          title: 'Category',
          minWidth: '150px',
          align: 'left',
        },
        {
          key: 'menuItemDetails',
          title: 'MenuItem to PrepItem Amount',
          minWidth: '180px',
          align: 'center',
          render: (_: any, record: IPrepItemTableData) => (
            <Button
              variant="outlined"
              size="small"
              onClick={() =>
                onMenuItemDetailsClick?.(record.key, record.prepItem)
              }
            >
              View Details
            </Button>
          ),
        },
        {
          key: 'onHandUnit',
          title: 'OnHand Unit',
          minWidth: '180px',
          align: 'left',
          render: (_: any, record: IPrepItemTableData) => (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <IconButton
                size="small"
                onClick={() =>
                  onOnHandUnitEditClick?.(record.key, record.prepItem)
                }
                sx={{
                  padding: '4px',
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  },
                }}
              >
                <EditIcon sx={{ fontSize: '1.1rem' }} />
              </IconButton>
              <span>{record.onHandUnit}</span>
            </div>
          ),
        },
        {
          key: 'restDays',
          title: 'Rest Days',
          minWidth: '120px',
          align: 'center',
          render: (_: any, record: IPrepItemTableData) => (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
              }}
            >
              <IconButton
                size="small"
                onClick={() =>
                  onRestDaysEditClick?.(
                    record.key,
                    record.prepItem,
                    record.restDays,
                  )
                }
                sx={{
                  padding: '4px',
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  },
                }}
              >
                <EditIcon sx={{ fontSize: '1.1rem' }} />
              </IconButton>
              <span>{record.restDays}</span>
            </div>
          ),
        },
      ] as IColumnsType<IPrepItemTableData>[],
    [
      onMenuItemDetailsClick,
      onEditClick,
      onRestDaysEditClick,
      onOnHandUnitEditClick,
    ],
  )
}

export default usePrepItemCategoryColumns
